import SchedulingOthersRegistration from './SchedulingOthersRegistration';

export default SchedulingOthersRegistration;